import styled from 'styled-components';
import NotePadImage from '@assets/images/notes/note-empty-state.svg';

export const NotePad = styled(NotePadImage)`
  width: ${({ theme }) => theme.x8spacePx}px;
  height: ${({ theme }) => theme.x8spacePx + 2}px;
  transform: translateX(4px);
`;
